import React from 'react';
import PropTypes from 'prop-types';
import renderHTML from 'react-render-html';
import { TextWrapper, TextInner, RichTextWrapper } from '../styles/titleAndText.style';
import { BlueButton, BlueButtonExternal, RTE } from '../../../utils/atoms';

/**
 * Determines if the lunk is internal external
 * @param {object} param0 incoming props
 * @returns {XML} An outgoing link
 */
const ctaLinkRender = ({ ctaLink, ctaText }) => {
  if (ctaLink && ctaLink.match(/^https?:/i)) {
    return (
      <BlueButtonExternal href={ctaLink} label={ctaText} target="blank">
        <span>{ctaText}</span>
      </BlueButtonExternal>
    );
  }
  return (
    <BlueButton to={ctaLink} label={ctaText}>
      <span>{ctaText}</span>
    </BlueButton>
  );
};

const propTypes = {
  backgroundImage: PropTypes.object,
  ctaLink: PropTypes.string,
  ctaText: PropTypes.string,
  richTextDescription: PropTypes.object,
  textAlignment: PropTypes.string,
  title: PropTypes.string,
  titleImage: PropTypes.object,
};
const defaultProps = {
  backgroundImage: {},
  ctaLink: null,
  ctaText: null,
  richTextDescription: {},
  textAlignment: null,
  title: null,
  titleImage: {},
};

/**
 * Title and Text Component
 * @param {object} param0 Incoming props
 * @returns {XML} A Title and Text Component
 */
const TitleAndText = ({
  backgroundImage, ctaLink, ctaText, richTextDescription, textAlignment, title, titleImage, titleSlug,
}) => {
  let textAlignmentClass = 'left-aligned';
  if (textAlignment === 'Center Aligned') {
    textAlignmentClass = 'center-aligned';
  } else if (textAlignment === 'Right Aligned') {
    textAlignmentClass = 'right-aligned';
  }
  return (
    <TextWrapper backgroundImage={backgroundImage && backgroundImage.file ? backgroundImage.file.url : ''}>
      <TextInner className={textAlignmentClass}>
        {titleImage && titleImage.file ? (
          <img className="title-image" src={titleImage.file.url} alt="title" />
        ) : (
          <h3 {...(titleSlug && { id: titleSlug })} className="title">{title}</h3>
        )}
        <RichTextWrapper>
          {richTextDescription
            && richTextDescription.childMarkdownRemark && (
            <RTE className="rich-text">{renderHTML(richTextDescription.childMarkdownRemark.html)}</RTE>
          )}
        </RichTextWrapper>
        {ctaLink && ctaText && ctaLinkRender({ ctaLink, ctaText })}
      </TextInner>
    </TextWrapper>
  );
};

TitleAndText.propTypes = propTypes;
TitleAndText.defaultProps = defaultProps;

export default TitleAndText;



// WEBPACK FOOTER //
// ./src/components/title-text/components/titleAndText.js